<template>
  <div class="container-fluid">
    <black-list-user-form
      :loading="loading"
      :user="user"
      :blackListUserData="blackListUser"
      :formErrors="formErrors"
      @blackListUserSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultBlackListUser from "../defaultBlackListUser";
import BlackListUserForm from "../partials/BlackListUserForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BlackListUserForm,
  },

  mixins: [alertLeave],
  props: ["user"],

  data() {
    const blackListUser = cloneDeep(defaultBlackListUser);
    const me = this.$store.getters["profile/me"];
    return {
      blackListUser: blackListUser,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(blackListUser) {
      this.loading = true;

      const blackListUserData = cloneDeep(blackListUser);
      delete blackListUserData.id;

      try {
        await this.$store.dispatch("blackListUsers/add", blackListUserData);
        this.$notify({
          type: "success",
          message: this.$t("BLACK_LIST_USERS.BLACK_LIST_USER_ADDED"),
        });
        const blackListUser = this.$store.getters["blackListUsers/blackListUser"];
        if(this.user){
          this.$emit("blackListUserCreated");
        }else{
          this.$emit("onViewBlackListUser", blackListUser, true);
        }
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
